// extracted by mini-css-extract-plugin
module.exports = {"divider":"textDivider_divider__3tkpL","line":"textDivider_line__1-nVw","text":"textDivider_text__1HP0e"};